// Angular
import { Component, HostBinding } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
	selector: 'cv-custom-tooltip-flag-cell',
	templateUrl: './custom-tooltip-cell.component.html',
	styleUrls: ['./custom-tooltip-cell.component.scss']
})
export class CustomTooltipFlagCellComponent implements ICellRendererAngularComp {
	public cellValue: any;
	public hasTooltip: string;

	@HostBinding('class')
	get themeClass(): string {
		return this.hasTooltip;
	}
	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.value;
		this.hasTooltip = !this.cellValue ? '' : 'ag-tooltip-hiding';
	}

	/**
	 * Put back the value
	 * @param params
	 */
	 refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
